// External libraries
import styled from 'styled-components';

// Zocdoc libraries
import { coral } from '@zocdoc/branding/colors';
import { sharpSansMedium } from '@zocdoc-frontend-common/styles-typography';

const ErrorMessage = styled.span`
    ${sharpSansMedium(15, 24)}
    color: ${coral};
`;

export { ErrorMessage as default, ErrorMessage };
